import { Injectable } from '@angular/core';
import { AuthService } from '../../../../../core';
import { isStatusEmAnalise, isStatusNaoConfirmada } from '../../status';

/** Service que valida os acessos e execuções de funcionalidades de análises das campanhas */
@Injectable({
    providedIn: 'root'
})
export class CampanhaAnaliseAuthGuardService {

    constructor(private authService: AuthService) { }

    /** Verifica se pode solicitar análise da campanha */
    canSolicitar(idCampanha: number, status: number, idUsuarioCreated: number): boolean {
        if (!idCampanha || idCampanha < 0) {
            return false;
        }

        // Somente admins ou usuário que criou a campanha pode solicitar sua análise
        if (!this.authService.isAdministrador() && (idUsuarioCreated !== this.authService.getIdUsuario())) {
            return false;
        }

        // Somente permite solicitar análise de campanhas com status igual a "Não Confirmada"
        return isStatusNaoConfirmada(status);
    }

    /** Verifica se pode enviar a análise da campanha */
    canEnviar(idCampanha: number, status: number, quantidadePedidosVendasNaoLiberados: number, quantidadePedidosBonificacoesNaoLiberados: number): boolean {
        if (!idCampanha || idCampanha < 0) {
            return false;
        }

        // Se possuir algum pedido não liberado então não pode enviar a análise por que a campanha está em análise apenas para resolver as pendências de pedidos não liberados
        if (quantidadePedidosVendasNaoLiberados > 0 || quantidadePedidosBonificacoesNaoLiberados > 0) {
            return false;
        }

        // Somente permite enviar a análise de campanhas com status igual a "Em Análise" e o usuário possuir permissão para analisar campanhas
        return isStatusEmAnalise(status) && this.authService.podeAnalisarCampanhas();
    }
}
